import { getStatusForId } from '@ms/yammer-data-support';

import type { User, YammerState } from '../../state/types';
import { createFindById } from '../findById';
import type { FindById } from '../findById';

/**
 * @deprecated PERFORMANCE This returns an object which will force unnecessary re-renders any time it changes. Selectors should
 * return a primitive value. This should be replaced by individual selectors for totalUserCount and currentNetworkTotalMembersCount.
 */
export const getUserAudienceCountsById: FindById<'userAudienceCounts'> = createFindById('userAudienceCounts');

type GetStatusForUserAudienceCounts = (state: YammerState, userId: User['id']) => ReturnType<typeof getStatusForId>;
export const getStatusForUserAudienceCounts: GetStatusForUserAudienceCounts = (state, userId) =>
  getStatusForId(state.userAudienceCounts, userId);
